import tippy from "tippy.js";

tippy("[data-tippy-popover]", {
	theme: "popover",
	arrow: true,
	trigger: "click",
	// zIndex: 9,
	allowHTML: true,
	content(reference) {
		const id = reference.getAttribute("data-tippy-popover");
		return document.getElementById(id).innerHTML;
	},
	onShow(instance) {
		instance.reference.classList.add("is-active");
	},
	onHide(instance) {
		instance.reference.classList.remove("is-active");
	}
});

tippy("[data-tippy-popover2]", {
	theme: "popover2",
	arrow: true,
	// trigger: "click",
	maxWidth: 530,
	// zIndex: 9,
	allowHTML: true,
	content: (reference) => document.getElementById(reference.getAttribute("data-tippy-popover2")).innerHTML,
	onShow(instance) {
		instance.reference.classList.add("is-active");
	},
	onHide(instance) {
		instance.reference.classList.remove("is-active");
	}
});

tippy("[data-tippy-stats]", {
	theme: "popover",
	arrow: true,
	trigger: "click",
	placement: "bottom-start",
	interactive: true,
	animateFill: false,
	animation: "fade",
	zIndex: 9,
	aria: {
		content: null,
		expanded: false,
	},
	appendTo: "parent",
	allowHTML: true,
	content: (reference) => document.getElementById(reference.getAttribute("data-tippy-stats")).innerHTML,
	onMount(instance) {
		instance.reference.setAttribute("aria-expanded", "true");
	},
	onShow(instance) {
		instance.reference.classList.add("is-active");
	},
	onHide(instance) {
		instance.reference.classList.remove("is-active");
		instance.reference.setAttribute("aria-expanded", "false");
	}
});

tippy(".js-language", {
	theme: "blank",
	interactive: true,
	animateFill: false,
	animation: "fade",
	allowHTML: true,
	// trigger: "click",
	content: (reference) => reference.querySelector("script").innerHTML,
	onShow() {
		document.documentElement.classList.add("fade");
	},
	onHide() {
		document.documentElement.classList.remove("fade");
	}
});
